export default __webpack_public_path__ + "static/media/mic-digital.c537c4b1.svg";